import React, { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MotionModal } from '../../../components/motion-modal/motion-modal';
import { useDeleteRecordings } from '../../../queries/ats/recordings/mutations';
import { SingleRecording } from '../../../queries/ats/recordings/types/recording';
import { FocusedAsset } from '../use-focused-asset';
import { appendSequenceNumbers } from '../utils';
import css from './delete-recording-modal.module.scss';

interface ConfirmDeleteEpisodeRecordingScreenProps {
  focusedAsset: FocusedAsset;
  recording: SingleRecording;
  setIsOpen: (isOpen: boolean) => void;
}

export function ConfirmDeleteEpisodeRecordingScreen({
  focusedAsset,
  recording,
  setIsOpen,
}: ConfirmDeleteEpisodeRecordingScreenProps) {
  const { mutate: deleteRecording, isLoading } = useDeleteRecordings({ onSuccess: () => setIsOpen(false) });
  const { t } = useTranslation();

  function handleMutate() {
    deleteRecording([recording.id]);
  }

  const label =
    focusedAsset.type === 'episode'
      ? appendSequenceNumbers(focusedAsset.series.titleName, focusedAsset)
      : focusedAsset.titleName;

  return (
    <Fragment>
      <p className={css.text}>
        <Trans i18nKey="delete-episode-description" ns="recordings" values={{ name: label }} />
      </p>

      <div className={css.actions}>
        <MotionModal.Button className={css.confirm} onClick={handleMutate} isLoading={isLoading}>
          {t('confirm')}
        </MotionModal.Button>
        <MotionModal.ViewBackButton className={css.cancel}>{t('cancel')}</MotionModal.ViewBackButton>
      </div>
    </Fragment>
  );
}
